import { useCallback, useRef } from 'react';
import { useVisibilityObserver } from '@core/hooks/useVisibilityObserver';
import { useContextTranslation } from '@core/i18n';
import { getCTATranslation } from '@core/i18n/cta/getCTATranslation';
import { usePIPTarget } from '@core/pictureInPicture/usePIPTarget';
import { useTrackCTAClick } from '@core/widgets/tracking/useTrackCTAClick';
import { useTrackCTAImpression } from '@core/widgets/tracking/useTrackCTAImpression';
import { PLAYER_DECK_CTA } from '@player/testIds';
import { CTALink, CTAWrapper } from './PlayerDeckContainer.styles';
/**
 *
 * @param param0
 * @returns
 */
export const PlayerDeckCTA = ({ video, params, appContext, }) => {
    const { t } = useContextTranslation();
    const ctaImpressionVideoTracked = useRef(null);
    const trackCTAImpression = useTrackCTAImpression(video);
    const trackCTAClick = useTrackCTAClick(video);
    const { url, onClick: onClickPIP } = usePIPTarget({
        url: video?.action_url || '',
        params,
    });
    const ctaRef = useVisibilityObserver({
        threshold: [0.8],
        onChange: useCallback((isVisible) => {
            if (isVisible && video && video !== ctaImpressionVideoTracked.current) {
                ctaImpressionVideoTracked.current = video;
                trackCTAImpression(appContext);
            }
        }, [trackCTAImpression, video, appContext]),
    });
    const onCTAButtonClick = useCallback((e) => {
        e.stopPropagation();
        trackCTAClick(appContext);
        onClickPIP(e);
    }, [appContext, onClickPIP, trackCTAClick]);
    return (video.action_type && (<CTAWrapper>
        <CTALink onClick={onCTAButtonClick} ref={ctaRef} href={url} target="_self" data-testid={PLAYER_DECK_CTA}>
          {video.action_type !== 'custom'
            ? getCTATranslation(t, video.action_type)
            : video.action_type_translation}
        </CTALink>
      </CTAWrapper>));
};
